/**
 * CSV out: RFC 4180 — fields quoted when they must be, quotes doubled, CRLF
 * between records — plus the two things a spreadsheet needs besides.
 *
 * - A byte-order mark in front (`CSV_BOM`), or Excel reads UTF-8 as the local
 *   code page and "Plaćanje" arrives as "PlaÄ‡anje".
 * - Text that a spreadsheet would run as a formula — anything starting with
 *   `=`, `+`, `-`, `@`, a tab or a carriage return — is prefixed with `'`.
 *   A bank's description is text someone else wrote; opening an export must
 *   not execute it. Numbers are numbers and go out as they are.
 */

export const CSV_BOM = '﻿'

const FORMULA = /^[=+\-@\t\r]/

function field(value) {
  if (value == null) return ''
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : ''
  let text = String(value)
  if (FORMULA.test(text)) text = `'${text}`
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

/** One CSV document: a header row, then one row per record. */
export function toCsv(header, rows) {
  return [header, ...rows].map((row) => row.map(field).join(',')).join('\r\n') + '\r\n'
}
